import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "..";
import {
  GET_ALL_INVOICE_PRODUCTS,
  ADD_INVOICE_PRODUCT, } from "../Queries/InvoiceProduct";
import { setLoader } from "./loaderSlice";
 
 
 
// GET ALL PRODUCTS
export const fetchInvoiceProducts = createAsyncThunk(
  "invoiceProducts/fetchAll",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true));
 
      const { data } = await client.query({
        query: GET_ALL_INVOICE_PRODUCTS,
        fetchPolicy: "network-only",
      });
 
      return data.getAllInvoiceProducts;
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setLoader(false));
    }
  }
);
 
// ADD PRODUCT
export const addInvoiceProductAsync = createAsyncThunk(
  "invoiceProducts/add",
  async (input, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true));
 
      const { data } = await client.mutate({
        mutation: ADD_INVOICE_PRODUCT,
        variables: { input },
      });
 
      return data.addInvoiceProduct;
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setLoader(false));
    }
  }
);
 
 
 
const initialState = {
  products: [],
  loading: false,
  error: null,
};
 
const invoiceProductsSlice = createSlice({
  name: "invoiceProducts",
  initialState,
  reducers: {
    setInvoiceProducts: (state, action) => {
      state.products = action.payload;
    },
    addInvoiceProductLocal: (state, action) => {
      state.products.unshift(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchInvoiceProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoiceProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchInvoiceProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
 
      // ADD
      .addCase(addInvoiceProductAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addInvoiceProductAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.products.unshift(action.payload);
      })
      .addCase(addInvoiceProductAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
 
export const {
  setInvoiceProducts,
  addInvoiceProductLocal,
} = invoiceProductsSlice.actions;
 
export default invoiceProductsSlice.reducer;
 